import React, { useState, useRef, useEffect } from 'react';
import Container from '../Container/Container';
import { useSelector } from 'react-redux';
import { get, post } from '../ApiServices/ApiServices';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendarAlt } from 'react-icons/fa';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Loader from './Component/Loader';

function getPriorSaturday() {
    const today = moment();
    const day = today.day();
    const diff = day === 6 ? 7 : day + 1;
    return today.clone().subtract(diff, 'days');
}

function getStartDate(endDate) {
    return moment(endDate, 'MM/DD/YYYY').subtract(11, 'month');
}

function ProcessReturns() {
    const navigate = useNavigate();
    const profile = useSelector((state) => state.profile.profile);

    const [weekEndingDate, setWeekEndingDate] = useState(
        getPriorSaturday().format('MM/DD/YYYY')
    );

    const [startDate, setStartDate] = useState(
        getStartDate(getPriorSaturday().format('MM/DD/YYYY')).format('MM/DD/YYYY')
    );

    const [weekLabel, setWeekLabel] = useState('');
    const [dateError, setDateError] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [historyProcess, setHistoryProcess] = useState([]);

    const confirmModalCloseRef = useRef(null);

    const Getgetprocess = async () => {
        try {
            setIsLoading(true);
            const api = `getprocessReturnHistory`;
            const totalData = await get(api);
            setHistoryProcess(totalData?.data);
        } catch (err) {
            console.error('Error fetching inventory data:', err);
            toast.error("Failed to fetch data");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        Getgetprocess();
    }, []);

    useEffect(() => {
        const end = moment(weekEndingDate, 'MM/DD/YYYY');
        const start = moment(startDate, 'MM/DD/YYYY');

        setWeekLabel(
            `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`
        );
    }, []);

    const handleNo = () => {
        setWeekEndingDate(getPriorSaturday().format('MM/DD/YYYY'));
        setDateError('');
        confirmModalCloseRef.current?.click();
    };

    const handleYes = async () => {
        const end = moment(weekEndingDate, 'MM/DD/YYYY', true);
        const start = moment(startDate, 'MM/DD/YYYY', true);

        if (!end.isValid() || !start.isValid()) {
            setDateError('Invalid date format');
            return;
        }

        if (end.isAfter(moment(), 'day')) {
            setDateError('Week-ending date cannot be future');
            return;
        }

        if (start.isAfter(end)) {
            setDateError('Start date cannot be after end date');
            return;
        }

        setDateError('');
        setIsProcessing(true);
        confirmModalCloseRef.current?.click();

        try {
            const response = await post('processReturns', {
                startDate: start.format('YYYY-MM-DD'),
                endDate: end.format('YYYY-MM-DD'),
            });

            if (response?.status) {
                Getgetprocess();
                toast.success(response?.message);
            } else {
                toast.error('Processing failed');
            }
        } catch (err) {
            toast.error('Something went wrong');
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <Container>

            {/* Global Loader */}
            {isProcessing ? <Loader /> :

                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">

                                <div className="nk-block-head nk-block-head-sm pbZeroHeadin">
                                    <div className="nk-block-between">
                                        <div className="nk-block-head-content">
                                            <h3 className="nk-block-title page-title">Process Returns</h3>
                                        </div>

                                        {profile?.name === 'Admin' && (
                                            <div className="nk-block-head-content">
                                                <button
                                                    className="btn btn-primary"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#processReturnsModal"
                                                    disabled={isProcessing}
                                                >
                                                    {isProcessing ? 'Processing...' : 'Process Returns'}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="card card-preview">
                                    <div className="card-inner">

                                        <h6 className="mb-3">Processing History</h6>

                                        <div style={{ border: '1px solid #000' }}>
                                            {isLoading ? (
                                                <Loader />
                                            ) : (
                                                historyProcess.map((entry, idx) => (
                                                    <div
                                                        key={idx}
                                                        style={{
                                                            display: 'flex',
                                                            borderBottom: idx !== historyProcess.length - 1 ? '1px solid #000' : 'none'
                                                        }}
                                                    >

                                                        <div style={{
                                                            width: '260px',
                                                            padding: '10px',
                                                            borderRight: '1px solid #000'
                                                        }}>
                                                            {moment.utc(entry.processed_at).format('MMMM D, YYYY [at] h:mm a')}
                                                        </div>

                                                        <div style={{ flex: 1, padding: '10px' }}>
                                                            <strong>Summary:</strong>

                                                            <ul style={{ marginTop: '8px', padding: 0, listStyle: 'none' }}>

                                                                <li style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 0' }}>
                                                                    <span>Orders marked as Returned</span>
                                                                    <span>{entry.returned_count}</span>
                                                                </li>

                                                                <li style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 0' }}>
                                                                    <span>Orders marked as Not Returned</span>
                                                                    <span>{entry.not_returned_count}</span>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>}

            <div className="modal fade" id="processReturnsModal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5>Process Returns</h5>
                            <button className="close" data-bs-dismiss="modal" ref={confirmModalCloseRef}>
                                ×
                            </button>
                        </div>

                        <div className="modal-body">

                            <p className="mb-3">
                                Do you want to process returns for the date range below?
                            </p>

                            <div className="mb-3">
                                <label>Week-ending (Saturday)</label>

                                <DateRangePicker
                                    initialSettings={{
                                        singleDatePicker: true,
                                        startDate: weekEndingDate
                                            ? moment(weekEndingDate, 'MM/DD/YYYY')
                                            : getPriorSaturday(),
                                        locale: {
                                            format: 'MMM D, YYYY',
                                        },
                                        opens: 'center',
                                        drops: 'down',
                                        autoApply: true,
                                        autoUpdateInput: false,
                                    }}
                                    onApply={(event, picker) => {
                                        const end = picker.startDate;

                                        if (end.day() !== 6) {
                                            toast.error('Please select a Saturday');
                                            return;
                                        }

                                        const start = end.clone().subtract(11, 'months');

                                        setWeekEndingDate(end.format('MM/DD/YYYY'));
                                        setStartDate(start.format('MM/DD/YYYY'));

                                        setWeekLabel(
                                            `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`
                                        );
                                    }}
                                >
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Select week-ending Saturday"
                                        value={weekLabel}
                                        readOnly
                                    />
                                </DateRangePicker>
                            </div>

                            {dateError && (
                                <div className="text-danger">{dateError}</div>
                            )}

                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={handleNo}>
                                No
                            </button>

                            <button className="btn btn-primary" onClick={handleYes} disabled={isProcessing}>
                                {isProcessing ? 'Processing...' : 'Yes'}
                            </button>
                        </div>

                    </div>
                </div>
            </div>

        </Container>
    );
}

export default ProcessReturns;
